import { type Tab } from 'rc-tabs/lib/interface';
import { CleanupTabs } from './constants';
import { TerrainCleanupGenerate } from './terrain-cleanup-generate';
import { TerrainCleanupGuide } from './terrain-cleanup-guide';

export const TerrainCleanupTabs: Tab[] = [
  {
    label: CleanupTabs.Generate,
    children: <TerrainCleanupGenerate />,
    key: CleanupTabs.Generate,
  },
  {
    label: CleanupTabs.Guide,
    children: <TerrainCleanupGuide />,
    key: CleanupTabs.Guide,
  },
];
